module.exports = __webpack_public_path__ + "static/media/chart_blue.748e39c9.png";